import cn from 'classnames/bind';
import React, { FC, FunctionComponent } from 'react';

import { Spinner, SpinnerSize } from '../Spinner';

import { PageSpinnerProps } from './PageSpinner.types';
import styles from './PageSpinner.module.css';

const cx = cn.bind(styles);

const PageSpinner: FunctionComponent<PageSpinnerProps> = (props) => {
    const {
        loadMore = false,
        noOffset = false,
        center = false,
        absoluteCenter = false,
        className,
    } = props;

    return (
        <div
            className={cx(
                'root',
                className,
                loadMore && 'root_load-more',
                noOffset && 'root_no-offset',
                center && 'root_center',
                absoluteCenter && 'root_absolute-center'
            )}
        >
            <Spinner size={SpinnerSize.BIG} />
        </div>
    );
};

export const RouteSkeleton: FC = () => <PageSpinner loadMore center />;

export default PageSpinner;
